import { create } from 'zustand';

export const useAdminStore = create((set) => ({
  profile: null,
  setProfile: (profile) => set({ profile }),
  auditToast: null,
  showAuditToast: (text) => set({ auditToast: text || 'Action complete. Audit logged.' }),
  clearAuditToast: () => set({ auditToast: null }),
}));
